import script from "./OrderHistoryGoodsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistoryGoodsDetail.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistoryGoodsDetail.vue?vue&type=style&index=0&id=84eef828&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84eef828"]])

export default __exports__